// extracted by css-extract-rspack-plugin
export default {"budget":"BudgetIncrease-module__budget--xqXXF","list":"BudgetIncrease-module__list--vUfNL","item":"BudgetIncrease-module__item--zWxwo"};